import React, {Component} from "react";
import {connect} from "react-redux";

import Paginator from "../../../../../utils/Paginator/Paginator.component";
import Drawer from "./../../../../../utils/Drawer/Drawer.component";
import CreateHall from "../CreateHall/CreateHall.component";
import HallsPageFiltersComponent from "./HallsPageFilters/HallsPageFilters.component";
import {HallsList} from "./HallsList.component";
import {HallsListLoading} from "./HallsListLoading.component";

import {hallsStoreSelectors} from "../../../store/store";
import {HallsActionCreators} from "../../../actions/actionCreators";
import {HallBaseConfig} from "../../../reducers/hallsList.reducer";
import {CreationModes} from "../../../reducers/creationMode.reducer";
import {HallsListFilters} from "../../../reducers/hallsListFilters.reducer";
import {ActionCreator} from "../../../../../actions/actions";
import {checkPermission} from "../../../../../utils/Authorization/authorization";

import "./HallsListPage.component.scss";

export interface HallsListPageContainerProps {
    hallsList: HallBaseConfig[];
    hallsCount: number;
    loading: boolean;
    lastRefresh: number;
    pageSize: number;
    onSearch: (string) => void;
    onPageChange: (number) => void;
    onRefresh: () => void;
    filters: HallsListFilters;
    updateCreationMode: ActionCreator;
    creationMode: any;
    clearCreateHall: ActionCreator;
    activateHall: ActionCreator;
    current_page: number;
}

class HallsListPage extends Component<HallsListPageContainerProps, {}> {
    createHall = () => {
        if (this.props.creationMode !== CreationModes.ADD_HALL) {
            this.props.clearCreateHall();
            this.props.updateCreationMode(CreationModes.ADD_HALL);
        }
    };

    closeCreateHall = () => {
        this.props.clearCreateHall();
    };

    render() {
        const loadingOrCards = this.props.loading ? (
            <HallsListLoading/>
        ) : (
            <HallsList
                activateHall={this.props.activateHall}
                filters={this.props.filters}
                hallsList={this.props.hallsList}
            />
        );

        const date = new Date(this.props.lastRefresh || 0).toLocaleTimeString();

        return (
            <div id="HallsList" className="content">
                <div className="container">
                    {checkPermission("create_hall") && (
                        <div className="row">
                            <div className="col-12 center-vertical buttons-col">
                                <a
                                    className="new-hall red-btn"
                                    onClick={this.createHall}
                                >
                                    <span>New Hall</span>
                                </a>
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div className="col-12">
                            <div className="hall-filters" key="hall-filters">
                                <HallsPageFiltersComponent
                                    loading={this.props.loading}
                                    getAllHalls={this.props.onRefresh}
                                    onPageChange={this.props.onPageChange}
                                />
                            </div>
                        </div>
                    </div>

                    {loadingOrCards}

                    {this.props.creationMode == CreationModes.ADD_HALL && (
                        <Drawer title="New Hall" onClose={this.closeCreateHall}>
                            <CreateHall/>
                        </Drawer>
                    )}
                </div>

                <div className="row halls-pagination container">
                    <div className="col-6 center-vertical last-update">
                        <p>{`Last update: ${date}`}</p>
                    </div>

                    <div className="col-6 center-vertical paginator">
                        {this.props.hallsList.length > 0 && (
                            <Paginator
                                currentPage={this.props.current_page + 1}
                                totalPages={Math.ceil(
                                    this.props.hallsCount / this.props.pageSize
                                )}
                                onPageChange={this.props.onPageChange}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creationMode: hallsStoreSelectors.creationMode(state)
});

const mapDispatchToProps = {
    updateCreationMode: HallsActionCreators.updateCreationMode,
    clearCreateHall: HallsActionCreators.clearCreateHall,
    activateHall: HallsActionCreators.activateHall
};

export default connect(mapStateToProps, mapDispatchToProps)(HallsListPage);
